export const ErrorMessages: ErrorMessages = {
	"errors/default": "Something went wrong! Please refresh the page or contact support.",
	"errors/unhandled": "Something went wrong! Please refresh the page or contact support.",
	"identity/incorrect-credentials": "Invalid username or password. Please check your credentials and try again.",
	"identity/user-not-found": "User not found! Please verify your username or contact support.",
	"identity/invalid-provider": "The provider you use to authenticate is not valid. Please try logging in with your Microsoft or Google account. You may also use your email and password",
	"identity/google/token-validation-error": "The token is not valid",
	"identity/microsoft/token-validation-error": "The token is not valid",
	"identity/multiple-emails-found": "Your email is connected to more than one account. Please contact support.",
	"account/account-not-found": "No accounts were found. Please contact support",
	"account/fuel-consumption-not-found": "No Fuel Consumption Data were found for account. Please contact support.",
	"assets/invalid-total-distance": "No total distance for assets found. Please contact support or try again.",
	"datepicker/date-range-one-month-max": "Date range should only be a maximum of 1 month",
	"driver/no-driver-access": "User has no access to the driver. Please contact support.",
	"driver-information/no-driver-access": "Driver provided has no access. Please verify and try again",
	"driver-information/no-driver-settings-found": "No settings found for the selected driver. Please add them.",
	"driver-information/upsert-validation-error": "SaturdayRate: Saturday rate must be greater than zero.",
	"driver-information/driver-id-exists": "ID number already exist.",
	"driver-information/driver-passport-exists": "Passport number already exist.",
	"vehicle-assignment/no-assigned-vehicle-found": "The assigned vehicle was not found.",
	"vehicle-assignment/invalid-assignment": "Assignment failed: The selected asset(s) may belong to different billing accounts.",
	"fuel-level/not-found": "Fuel Level does not exists",
	"fuel-level/access-denied": "You do not have permission to process the low fuel level alert",
	"account/no-asset-access": "User does not have access to the asset.",
	"parts-inventory/duplicate-part-in-warehouse": "Part already exists in the warehouse",
	"parts-inventory/part-not-found": "Part not found",
	"parts-inventory/invalid-transaction-quantity": "Transaction quantity must be greater than zero",
	"parts-inventory/invalid-transaction-type": "Invalid transaction type",
	"parts-inventory/insufficient-stock": "Insufficient stock for this transaction",
	"parts-inventory/work-order-parts-not-found": "There are no issued parts for the workorder supplied",
	"suppliers/supplier-is-deleted": "Cannot Update Supplier As it is Deleted. Please contact support.",
	"service-schedules/duplicate-service-schedule": "Service schedule already exists for the account",
	"service-schedules/service-schedule-not-found": "Service schedule not found. Please contact support.",
	"service-schedules/service-interval-not-found": "The selected service type has not been set up yet for this schedule",
	"service-schedules/cannot-modify-oem-schedule": "OEM maintenance plans are read-only. Only custom plans can be modified.",
	"service-schedules/oem-model-and-year-required": "The model and year are required for OEM service details.",
	"service-schedules/assets-already-assigned": "One or more selected assets are already assigned to another service schedule.",
	"maintenance-settings/workshop-not-found": "Workshop does not exist",
	"maintenance-overview/maintenance-not-found": "Maintenance not found",
	"compliance/compliance-record-not-found": "Compliance record not found.",
	"work-order/work-order-not-found": "No work order found for the work order number supplied",
	"maintenance-calendar/work-order-not-found": "No work order found for the maintenance event",
	"work-order/batch-size-exceeded": "The number of work orders exceeds the allowed batch size",
	"work-order/duplicate-in-batch": "Duplicate work order IDs were found in the request",
	"work-order/scheduled-date-in-past": "Scheduled date cannot be in the past",
	"work-order/invalid-technician": "One or more selected technicians are invalid"
}

export const InLineErrorMessages: ErrorMessages = {
	"identity/incorrect-credentials": "Incorrect username/password",
	"identity/user-not-found": "User not found"
}

export interface ErrorMessages {
	[key: string]: string;
}